export const ADD_PRODUIT_TYPE_PANNEAU = 'ADD_PRODUIT_TYPE_PANNEAU';
export const REMOVE_PRODUIT_TYPE_PANNEAU = 'REMOVE_PRODUIT_TYPE_PANNEAU';
export const TRIE_PRODUIT_TYPE_PANNEAU = 'TRIE_PRODUIT_TYPE_PANNEAU';
export const ADD_PRODUIT_TYPE_RESEAU_TEMPO = 'ADD_PRODUIT_TYPE_RESEAU_TEMPO';
export const REMOVE_PRODUIT_TYPE_RESEAU_TEMPO = 'REMOVE_PRODUIT_TYPE_RESEAU_TEMPO';
export const TRIE_PRODUIT_TYPE_RESEAU_TEMPO = 'TRIE_PRODUIT_TYPE_RESEAU_TEMPO';
export const SET_CLIENT_PANIER = 'SET_CLIENT_PANIER';
export const SET_CONTACT_PANIER = 'SET_CONTACT_PANIER';
export const SET_OUVRIR_ENVOI_MAIL = 'SET_OUVRIR_ENVOI_MAIL';
export const SET_OPPORTUNITE = 'SET_OPPORTUNITE';
export const RESET_PANIER = 'RESET_PANIER';
export const SET_DESTINATAIRES = 'SET_DESTINATAIRES';
export const SET_ADRESSE_PANIER = 'SET_ADRESSE_PANIER';
export const SET_DATE_VALIDITE = 'SET_DATE_VALIDITE';
export const SET_THEME_CAMPAGNE = 'SET_THEME_CAMPAGNE';
export const SET_PRODUIT_TYPE_RESEAU_TEMPO = 'SET_PRODUIT_TYPE_RESEAU_TEMPO';
export const SET_PANIER = 'SET_PANIER';
export const REMOVE_PRODUIT_TYPE_RESEAU_PERSO = 'REMOVE_PRODUIT_TYPE_RESEAU_PERSO';
export const ADD_PRODUIT_TYPE_RESEAU_PERSONNALISE = 'ADD_PRODUIT_TYPE_RESEAU_PERSONNALISE';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const ADD_PRODUIT_TYPE_RESEAU_LC = 'ADD_PRODUIT_TYPE_RESEAU_LC';
export const REMOVE_PRODUIT_TYPE_RESEAU_LC = 'REMOVE_PRODUIT_TYPE_RESEAU_LC';
export const ADD_PRODUIT_TYPE_PANNEAU_NUMERIQUE = 'ADD_PRODUIT_TYPE_PANNEAU_NUMERIQUE';
export const REMOVE_PRODUIT_TYPE_PANNEAU_NUMERIQUE = 'REMOVE_PRODUIT_TYPE_PANNEAU_NUMERIQUE';
export const ADD_PRODUIT_TYPE_RESEAU_NUMERIQUE = 'ADD_PRODUIT_TYPE_RESEAU_NUMERIQUE';
export const REMOVE_PRODUIT_TYPE_RESEAU_NUMERIQUE = 'REMOVE_PRODUIT_TYPE_RESEAU_NUMERIQUE';
export const SET_OPPORTUNITE_PANIER = 'SET_OPPORTUNITE_PANIER';
export const SET_MARKER_FACE_LC = 'SET_MARKER_FACE_LC';
export const SET_MARKER_PANNEAU_NUMERIQUE = 'SET_MARKER_PANNEAU_NUMERIQUE';
export const SET_ZOOM_CARTO = 'SET_ZOOM_CARTO';
export const SET_MARKER_FACE_RESEAUX_LC = 'SET_MARKER_FACE_RESEAUX_LC';
export const SET_MARKER_FACE_RESEAUX_TEMPO = 'SET_MARKER_FACE_RESEAUX_TEMPO';
export const SET_MARKER_FACE_RESEAUX_NUMERIQUE = 'SET_MARKER_FACE_RESEAUX_NUMERIQUE';
export const SET_MARKER_FACE_RESEAUX_PERSO = 'SET_MARKER_FACE_RESEAUX_PERSO';
export const ADD_ADRESSES_PRODUITS = 'ADD_ADRESSES_PRODUITS';
export const REMOVE_ADRESSES_PRODUITS = 'REMOVE_ADRESSES_PRODUITS';
export const SET_IS_MODIF = 'SET_IS_MODIF';
export const SET_IS_DUPLICATE = 'SET_IS_DUPLICATE';
export const SET_ID_OPP_MODIF = 'SET_ID_OPP_MODIF';
export const SET_PRODUITS_PANIER = 'SET_PRODUITS_PANIER';
export const SET_USER_IDENTIFIANT_OPP = 'SET_USER_IDENTIFIANT_OPP';
export const UPDATE_PRIX_GLOBAL = 'UPDATE_PRIX_GLOBAL';



// WEBPACK FOOTER //
// ./src/store/creationOpportunite/panier-mutation-type.js